import { Summary } from '@components';
import { iReviewFormValues, getSummaryScreen } from '@services/ReviewService';
import { useFormikContext } from 'formik';
import { ReactElement, useEffect } from 'react';

function ReviewStep13(): ReactElement {
  const { values }: { values: iReviewFormValues } = useFormikContext();
  useEffect(() => {
    values.CheckAndConfirmPageLoaded = true;
  }, []);
  return (
    <>
      <Summary summaryFields={getSummaryScreen(values)} />
    </>
  );
}

export default ReviewStep13;
